module.exports = __webpack_public_path__ + "img/mentor.df71808e.png";